/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for any purpose without the express written permission of Honeywell. */
import { createSlice } from "@reduxjs/toolkit";
import { Tenant, TenantState } from "../../models";
import {
  createTenantDetails,
  deleteTenant,
  editTenantDetails,
  fetchFilterCounts,
  getAvailableCountries,
  getAvailableCurrencies,
  getAvailableDataCenters,
  getAvailableProducts,
  getAvailableRegions,
  getAvailableTimeZones,
  getGeoMapping,
  getTenantDetailsByTenantId,
  getTenantLogo,
  uploadTenantLogoDetails,
} from "./tenant-actions";

const initialSliceState: TenantState = {
  tenants: [],
  tenantDeatailsByTenantId: {
    tenantId: "",
    tenantName: "",
    timezone: "",
    datacenter: "",
    currency: "",
    lastUpdatedTimeStamp: "",
    region: 0,
    address: {
      street: "",
      city: "",
      state: "",
      country: 0,
      zipcode: "",
    },
    createdon: "",
    version: 0,
    statusCode: 0,
  },
  totalQuantity: 0,

  availableTimeZones: [],
  availableCurrencies: [],
  availableProducts: [],

  availableDataCentres: [],
  tenantEdited: false,

  /// Tenant List Slice:
  filterTenants: [],
  applicationstoFilterTenants: [],
  filterApp: [],
  filterRegion: [],
  hasError: false,
  errorCode: null,
  exportedData: [],
  availableCountries: [],
  availableRegions: [],
  filterData: {},
  filteredjson: {
    assignedApps: [],
    region: [],
  },
  forgeCustomerTenantDataUserPage: {},
  currentTenantIdOfLoadedUsers: "",
  geoMapping: { regionDataMap: [], countryDataMap: [] },
  TabErrorMapping: [],
  isLoadingIndicatorActiveTenant: false,
};

const tenantSlice = createSlice({
  name: "tenant",
  initialState: initialSliceState,

  extraReducers(builder) {
    builder
      .addCase(getAvailableDataCenters.fulfilled, (state, action: any) => {
        state.availableDataCentres = action.payload.data;
      })
      .addCase(getAvailableDataCenters.rejected, (state, action) => {})
      .addCase(getAvailableDataCenters.pending, (state) => {});

    // get geomapping
    builder
      .addCase(getGeoMapping.fulfilled, (state, action: any) => {
        state.geoMapping = action.payload.data;
      })
      .addCase(getGeoMapping.rejected, (state, action) => {})
      .addCase(getGeoMapping.pending, (state) => {});

    /// get available timezones
    builder
      .addCase(getAvailableTimeZones.fulfilled, (state, action: any) => {
        state.availableTimeZones = action.payload.data;
      })
      .addCase(getAvailableTimeZones.rejected, (state, action) => {})
      .addCase(getAvailableTimeZones.pending, (state) => {});

    /// get available currencies
    builder
      .addCase(getAvailableCurrencies.fulfilled, (state, action: any) => {
        state.availableCurrencies = action.payload.data;
      })
      .addCase(getAvailableCurrencies.rejected, (state, action) => {})
      .addCase(getAvailableCurrencies.pending, (state) => {});

    /// get available products
    builder
      .addCase(getAvailableProducts.fulfilled, (state, action: any) => {
        state.availableProducts = action.payload.data;
      })
      .addCase(getAvailableProducts.rejected, (state, action) => {})
      .addCase(getAvailableProducts.pending, (state) => {});

    // get tenant Details by tenant id
    builder
      .addCase(getTenantDetailsByTenantId.fulfilled, (state, action: any) => {
        state.tenantDeatailsByTenantId = action.payload;
        state.isLoadingIndicatorActiveTenant = false;
      })
      .addCase(getTenantDetailsByTenantId.rejected, (state, action: any) => {
        state.tenantDeatailsByTenantId = action.payload;
        state.isLoadingIndicatorActiveTenant = false;
      })
      .addCase(getTenantDetailsByTenantId.pending, (state) => {
        state.isLoadingIndicatorActiveTenant = true;
      });

    // get filter Count
    builder
      .addCase(fetchFilterCounts.fulfilled, (state, action: any) => {
        state.filterData = action.payload;
      })
      .addCase(fetchFilterCounts.rejected, (state, action) => {})
      .addCase(fetchFilterCounts.pending, (state) => {});

    // delete tenant
    builder
      .addCase(deleteTenant.fulfilled, (state, action: any) => {
        state.tenants = state.tenants.filter(
          (x) => x.tenantId != action.payload
        );
      })
      .addCase(deleteTenant.rejected, (state, action) => {})
      .addCase(deleteTenant.pending, (state) => {});
    // Create Tenant
    builder
      .addCase(createTenantDetails.fulfilled, (state, action: any) => {
        /// Add the tenant to the list
        state.tenantDeatailsByTenantId = action.payload;
      })
      .addCase(createTenantDetails.rejected, (state, action: any) => {
        state.tenantDeatailsByTenantId = action.payload;
      })
      .addCase(createTenantDetails.pending, (state) => {});
    // End create tenant
    // Edit tenant
    builder
      .addCase(editTenantDetails.fulfilled, (state, action: any) => {
        state.tenantDeatailsByTenantId = {
          ...state.tenantDeatailsByTenantId,
          headquarterAddress: action?.payload?.headquarterAddress,
          timezone: action?.payload?.timezone,
          datacenter: action?.payload?.datacenter,
          currency: action?.payload?.currency,
          region: action?.payload?.region,
          address: action?.payload?.address,
          version: action?.payload?.version,
          status: action?.payload?.status,
          products: action?.payload?.products,
          lastUpdatedTimeStamp: action?.payload?.lastUpdatedTimeStamp,
          createdon: action?.payload?.createdon,
        };
        // const tenanttoUpdate = state.tenants.find(
        //   (x) => x.tenantId === action.payload.id
        // );
        // Object.assign(tenanttoUpdate as Tenant, action.payload as Tenant);
        // state.tenants = [...state.tenants];
      })
      .addCase(editTenantDetails.rejected, (state, action) => {})
      .addCase(editTenantDetails.pending, (state) => {});
    // End edit tenant
    /// Update logo
    builder
      .addCase(uploadTenantLogoDetails.fulfilled, (state, action: any) => {})
      .addCase(uploadTenantLogoDetails.rejected, (state, action) => {})
      .addCase(uploadTenantLogoDetails.pending, (state) => {});
    /// End update logo

    //Get Logo
    builder
      .addCase(getTenantLogo.fulfilled, (state, action: any) => {})
      .addCase(getTenantLogo.rejected, (state, action) => {})
      .addCase(getTenantLogo.pending, (state) => {});
    //Update Logo
    //Fetch Regions
    builder
      .addCase(getAvailableRegions.fulfilled, (state, action: any) => {
        state.availableRegions = action.payload.data;
      })
      .addCase(getAvailableRegions.rejected, (state, action) => {})
      .addCase(getAvailableRegions.pending, (state) => {});
    //Fetch Countries
    builder
      .addCase(getAvailableCountries.fulfilled, (state, action: any) => {
        state.availableCountries = action.payload.data;
      })
      .addCase(getAvailableCountries.rejected, (state, action) => {})
      .addCase(getAvailableCountries.pending, (state) => {});
  },
  reducers: {
    tenantEdited(
      state: TenantState,
      action: {
        payload: boolean;
      }
    ) {
      state.tenantEdited = action.payload;
    },
    /// Tenant List slice:
    createfilteredList(state, action) {
      state.filterTenants = action.payload;
    },

    showTenantList(state, action) {
      state.tenants = action.payload;
      state.filterTenants = action.payload;
    },
    showFilteredList(state, action) {
      state.applicationstoFilterTenants = action.payload;
    },

    showExportedData(state, action) {
      state.exportedData = action.payload;
    },
    filterusingselectedApplication(state, action) {
      state.filterApp = action.payload;
    },
    filterusingselectedLocation(state, action) {
      state.filterRegion = action.payload;
    },
    filerTenantsBasedOnSearchText(state, action) {
      let searchText = action.payload;
      let searchedTenants = state.tenants.filter(
        (x: any) =>
          (x.tenantName as string)
            .toLowerCase()
            .includes(searchText.toLowerCase()) ||
          ((x as any).addressLine1 as string)
            .toLowerCase()
            .includes(searchText.toLowerCase())
      );
      state.filterTenants = searchedTenants;
      if (
        searchedTenants === null ||
        searchedTenants.length === 0 ||
        searchedTenants === undefined
      ) {
        state.hasError = false;
        state.errorCode = null;
      }
    },

    gettenantLogo(state, action) {
      state.tenantLogo = action.payload;
    },
    gettenantbyID(
      state,
      action: {
        payload: string;
      }
    ) {
      state.currentTenantID = action.payload;
    },

    resetErrorAsItsAlreadyDisplayed(state) {
      state.errorCode = null;
      state.hasError = false;
    },

    getCurrentTenantIdOfLoadedUsers(state, action) {
      state.currentTenantIdOfLoadedUsers = action.payload;
    },
    getForgeCustomerTenantDataUserPage(state, action) {
      state.forgeCustomerTenantDataUserPage = action.payload;
    },

    // Update this network error for products whose settings could not be saved
    updateSettingsNetworkError(state, action) {
      if (!state) return; // If state is not present, return

      state.TabErrorMapping = state.TabErrorMapping?.map((x: any) => {
        if (x.key === action.payload.tabName) {
          return {
            ...x,
            value: {
              isNetworkError: true,
              errorCount: 0,
            },
          };
        }
        return x;
      });
    },

    // Reset settings error after all API calls for settings save are success
    resetSettingsError(state) {
      state.TabErrorMapping = [];
    },
    // Update Tab and error mapping
    updateTabErrorCountMapping(state: any, action: any) {
      // coverity issue fix
      if (!state) return; // If state is not present, return
      // If the key is not present, add that key
      if (
        state.TabErrorMapping?.find(
          (x: any) => x.key === action.payload.tabName
        )
      ) {
        state.TabErrorMapping = state?.TabErrorMapping?.map((x: any) => {
          if (x.key === action.payload.tabName) {
            return {
              ...x,
              value: {
                isNetworkError: undefined,
                errorCount: action.payload.errorCount,
              },
            };
          }
          return x;
        });
      } else {
        // If the key is present, update the value
        state.TabErrorMapping.push({
          key: action.payload.tabName,
          value: {
            isNetworkError: undefined,
            errorCount: action.payload.errorCount,
          },
        });
      }
      // If the key is present, update the value
      //state.TabErrorMapping = action.payload;
    },
  },
});

export const tenantActions = tenantSlice.actions;

export default tenantSlice;
